export function removeLeadingZeros(input) {
  // Replace leading zeros with an empty string, then check if the result is empty
  const result = input.replace(/^0+/, '0');
  return result === '' ? '' : result;
}